module.exports = __webpack_public_path__ + "static/media/email.d53a7027.png";